module.exports = __webpack_public_path__ + "static/media/image3.fcdf559f.jpg";